<template>
  <div class="flex-grow">
    <el-row>
      <el-col :span="10" class="flex-start">
        <div class="flex-start">
          <el-image
            :title="user.storesName"
            class="flex-shrink"
            style="width: 40px; height: 40px; border-radius: 4px"
            :src="user.logo"
            fit="fill"
          ></el-image>
          <p class="gap-l title text-1">
            {{ user.storeName }}
          </p>
          <div class="gap-l flex-shrink">
            <p>{{ week }}</p>
            <p class="mt-x">{{ dateTime }}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="14" class="flex-end">
        <div class="gap-l room-search flex-start">
          <div class="relative">
            <input
              class="input"
              type="text"
              placeholder="请输入房号"
              v-model="number"
              autocomplete="off"
              :readonly="readonly"
              @focus="readonly = false"
              @blur="readonly = true"
              @change="roomSearch"
            />
            <i
              class="el-icon-error"
              v-show="number.length"
              @click="number = ''"
            ></i>
          </div>
          <button class="button" @click="roomSearch">客房查询</button>
        </div>
        <button v-if="inOutPermission" class="button gap-l" @click="inOut">
          入住/退房
        </button>
        <!-- <button class="button ml-3x" @click="openAir">开空调</button> -->
        <el-dropdown @command="handleControl">
          <button class="button gap-l">
            客控工具

            <i class="el-icon-arrow-down el-icon--right"></i>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="showControlsPreset"
              >预设设置</el-dropdown-item
            >
            <el-dropdown-item command="controlsAir">空调集控</el-dropdown-item>
            <el-dropdown-item command="controlsCurtain"
              >窗帘集控</el-dropdown-item
            >
            <el-dropdown-item command="controlsAeration"
              >换气集控</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <template v-if="playing">
          <div class="gap-l flex-start pointer" v-if="!muted" @click="pause">
            <svg
              t="1683272117040"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2880"
              width="24"
              height="24"
            >
              <path
                d="M872.802928 755.99406 872.864326 755.99406 872.864326 755.624646Z"
                fill="rgba(255,255,255,0.3)"
                p-id="2881"
              ></path>
              <path
                d="M744.055658 192.799074c-4.814656-2.889817-9.601682-5.251607-15.442714-5.251607-14.262842 0-25.758664 11.559267-25.758664 25.805736 0 10.285251 6.088672 18.519796 14.6957 23.195282 94.679359 55.247278 158.344355 157.787676 158.344355 275.30416 0 117.424386-63.605643 219.931015-158.159136 275.18034-8.29492 4.538363-15.442714 13.050224-15.442714 23.583115 0 14.261818 11.559267 25.820062 25.791409 25.820062 5.716188 0 10.252505-2.202155 15.22475-5.063319 109.871363-64.133669 183.764304-183.143157 183.764304-319.520197C927.074995 375.785665 853.495186 257.010515 744.055658 192.799074z"
                fill="rgba(255,255,255,0.3)"
                p-id="2882"
              ></path>
              <path
                d="M773.946432 511.867994c0-79.96524-43.344181-149.739373-107.821681-187.289594-2.920516-1.52268-9.785877-4.520967-14.603603-4.520967-14.325263 0-25.914206 11.589966-25.914206 25.89988 0 9.616008 5.096065 18.176988 12.865006 22.666232 49.839105 28.307719 83.45983 81.829703 83.45983 143.244448 0 62.472843-34.801621 116.817566-86.070284 144.750755-7.457856 4.538363-12.397355 12.803607-12.397355 22.188348 0 14.325263 11.588943 25.943882 25.882484 25.943882 6.090718 0.031722 13.33061-3.542686 13.33061-3.542686C729.048873 664.171772 773.946432 593.294514 773.946432 511.867994z"
                fill="rgba(255,255,255,0.3)"
                p-id="2883"
              ></path>
              <path
                d="M541.3694 124.672464c-10.846022-5.219885-23.740704-3.790326-33.215496 3.712555-0.435928 0.358157-46.423309 36.914748-97.195669 74.296123-88.308255 65.081251-114.036219 75.925227-119.257128 77.649498l-110.6194 0c-0.63752 0-1.243317 0.062422-1.879813 0.093121l-56.504922 0c-14.231119 0-25.775037 11.543917-25.775037 25.775037l0 411.697573c0 14.261818 11.512195 25.761734 25.775037 25.761734l189.511191 0.027629c5.096065 1.865487 29.395494 13.0799 107.761306 76.999698 45.613874 37.162388 86.505189 73.485665 86.940095 73.829496 5.841032 5.218862 13.298887 7.92039 20.820188 7.92039 4.349051 0 8.729825-0.930185 12.862959-2.764973 11.277858-5.064342 18.517749-16.252149 18.517749-28.619828 0 0 0.031722-97.257068 0.031722-132.212184 0.808412-2.484587 1.213641-5.127787 1.213641-7.863085 0-2.792603-1.245364-578.026786-1.245364-578.026786C559.110459 140.892891 552.214399 129.924071 541.3694 124.672464zM508.308423 726.470653c0 1.494027-0.467651 94.617961-0.467651 94.617961-13.889335-11.745509-29.332049-24.64019-45.240367-37.507242-104.59008-84.702124-130.505309-91.816149-148.030451-91.816149-0.372483 0-0.683569 0.091074-1.025353 0.091074s-0.652869-0.091074-1.025353-0.091074L170.394297 691.765223c-18.037818 0-22.248723-5.128811-22.248723-23.246447L148.145573 352.559685c0-12.32163 1.461281-20.057825 16.298198-20.057825l128.065747 0c17.090237 0 43.315528-6.991228 157.787676-90.839915 20.383236-14.914688 40.330544-29.938869 57.544601-43.113937 0 0 0.373507 445.207781 0.467651 521.368368C507.779374 722.028481 508.308423 724.234729 508.308423 726.470653z"
                fill="rgba(255,255,255,0.3)"
                p-id="2884"
              ></path>
            </svg>
            <span class="font-l ml-x">警报开启</span>
          </div>
          <!-- 静音 -->
          <div v-else class="gap-l flex-start pointer" @click="play">
            <svg
              t="1683271812367"
              class="icon"
              viewBox="0 0 1026 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7953"
              width="24"
              height="24"
            >
              <path
                d="M240.023158 329.356725H144.719298c-8.819774 0-15.968811 7.149037-15.968811 15.968811v328.358675c0 8.819774 7.149037 15.968811 15.968811 15.96881h193.621833c0 0.07685 0.036928 0.149708 0.099805 0.195618l182.323898 133.236772a7.984405 7.984405 0 0 0 12.695205-6.446409V622.793606l64.374269 64.374269v240.995306c0 8.819774-7.149037 15.968811-15.968811 15.968811a15.968811 15.968811 0 0 1-9.422596-3.075992L320.078799 756.605255a15.968811 15.968811 0 0 0-9.422596-3.07699H128.750487c-35.277099 0-63.875244-28.598144-63.875243-63.875244V329.356725c0-35.277099 28.598144-63.875244 63.875243-63.875244h47.397427l63.875244 63.875244zM533.460039 442.126472V203.34584a7.984405 7.984405 0 0 0-12.695205-6.446409l-134.351594 98.180242-45.171774-45.171774L572.443899 80.92694c7.120094-5.204834 17.110581-3.650869 22.314417 3.469224A15.968811 15.968811 0 0 1 597.834308 93.816764v412.683977l-64.374269-64.374269z m336.776234 336.776234l-43.516008-43.51501C873.074729 672.799938 896.251462 598.005021 896.251462 511.001949c0-138.745014-58.939883-246.440671-176.820647-323.088967A47.906433 47.906433 0 0 1 697.639376 147.751423V144.717349c0-14.036585 11.378776-25.415361 25.415361-25.415361 4.359485 0 8.644117 1.120811 12.445692 3.255642C885.249949 206.655376 960.126706 336.137481 960.126706 511.001949c0 114.37062-40.59671 203.053411-89.890433 267.900757z m-90.129965 90.537169C737.183142 902.479345 702.280312 917.638737 697.639376 916.210526c-12.974659-3.992203-19.961014-16.269224-19.961013-34.931774 0-11.10531 5.301645-21.265466 15.903937-30.480467a45.910331 45.910331 0 0 1 6.746823-4.863501c11.948663-7.066199 23.35239-14.421832 34.208187-22.063907l45.568998 45.568998z m0.504016-180.163119l-47.753731-47.753731C755.502363 603.286706 768.500975 558.661864 768.500975 511.001949c0-88.404335-44.723649-166.363072-112.779727-212.48499-15.968811-11.078363-33.933723-31.039376-29.941521-48.006238s17.964912-29.94152 29.941521-25.916382C760.489622 277.271454 832.376218 385.741598 832.376218 511.001949c0 67.674823-18.361138 128.419181-51.765894 178.274807zM688.117973 777.45154A323.332491 323.332491 0 0 1 664.703704 790.45614c-13.97271 4.895439-24.951267 4.990253-36.927876-14.97076-9.769918-16.283197-1.60786-29.909583 15.275166-43.100819l45.066979 45.065981zM90.7537 90.752749c12.472639-12.472639 32.694144-12.472639 45.166783 0L936.922027 891.753294c12.472639 12.472639 12.472639 32.694144 0 45.166784s-32.694144 12.472639-45.166783 0L90.754698 135.918534c-12.472639-12.472639-12.472639-32.694144 0-45.166784z"
                fill="rgba(255,255,255,0.3)"
                p-id="7954"
              ></path>
            </svg>
            <span class="font-l ml-x">警报关闭</span>
          </div>
        </template>

        <div class="gap-l flex-start pointer" @click="showHelp = true">
          <svg
            t="1683187378291"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2605"
            width="24"
            height="24"
          >
            <path
              d="M463.99957 784.352211c0 26.509985 21.490445 48.00043 48.00043 48.00043s48.00043-21.490445 48.00043-48.00043c0-26.509985-21.490445-48.00043-48.00043-48.00043S463.99957 757.842226 463.99957 784.352211z"
              fill="#f7f7f7"
              p-id="2606"
            ></path>
            <path
              d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128.287273c-211.584464 0-383.712727 172.128262-383.712727 383.712727 0 211.551781 172.128262 383.712727 383.712727 383.712727 211.551781 0 383.712727-172.159226 383.712727-383.712727C895.712727 300.415536 723.551781 128.287273 512 128.287273z"
              fill="#f7f7f7"
              p-id="2607"
            ></path>
            <path
              d="M512 673.695256c-17.664722 0-32.00086-14.336138-32.00086-31.99914l0-54.112297c0-52.352533 39.999785-92.352318 75.32751-127.647359 25.887273-25.919957 52.67249-52.67249 52.67249-74.016718 0-53.343368-43.07206-96.735385-95.99914-96.735385-53.823303 0-95.99914 41.535923-95.99914 94.559333 0 17.664722-14.336138 31.99914-32.00086 31.99914s-32.00086-14.336138-32.00086-31.99914c0-87.423948 71.775299-158.559333 160.00086-158.559333s160.00086 72.095256 160.00086 160.735385c0 47.904099-36.32028 84.191695-71.424378 119.295794-27.839699 27.776052-56.575622 56.511974-56.575622 82.3356l0 54.112297C544.00086 659.328155 529.664722 673.695256 512 673.695256z"
              fill="#f7f7f7"
              p-id="2608"
            ></path>
          </svg>
          <span class="font-l ml-x">帮助</span>
        </div>
        <div class="gap-l flex-start pointer" @click="backOld">
          <i class="el-icon-back font-xl"></i>
          <span class="font-l ml-x">回到旧版</span>
        </div>

        <!-- 用户名下拉菜单 -->
        <el-dropdown class="gap-l pointer user" @command="handleCommand">
          <div>
            <i class="el-icon-user font-xxl text-v"></i>
            <span class="font-l text-v">
              {{ userName }}
              <i class="el-icon-caret-bottom"></i>
            </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided command="password">
              <i class="el-icon-edit-outline font-l"></i>
              <span>修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <i class="el-icon-position font-l"></i>

              退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>

    <!-- 入住、退房弹窗 -->
    <hand-in-out :visible.sync="visibleInOut" @update="update"></hand-in-out>

    <!-- 重置密码弹窗 -->
    <reset-password :visible.sync="visibleReset"></reset-password>

    <!-- 帮助弹窗 -->
    <the-header-help :visible.sync="showHelp"></the-header-help>
  </div>
</template>

<script>
import moment from "moment";
import ResetPassword from "@/components/common/ResetPassword";
import HandInOut from "@/components/page/control/components/HandInOut";
import TheHeaderHelp from "./TheHeaderHelp.vue";
export default {
  name: "TheHeader",

  props: {
    // 报警中
    playing: {
      type: Boolean,
      default: false,
    },
    // 已静音
    muted: {
      type: Boolean,
      default: false,
    },
  },

  components: { ResetPassword, HandInOut, TheHeaderHelp },

  data() {
    return {
      dateTime: "", // 时间
      week: "", // 星期
      timer: null,

      number: "", // 房号
      userName: "",

      tempRoom: {},

      visibleRoomControl: false,
      visibleReset: false, // 重置密码弹窗
      visibleAir: false,
      visibleInOut: false,
      readonly: false,
      showHelp: false,
    };
  },

  created() {
    this.getTime();
    this.setInterval();
    this.userName = sessionStorage.getItem("username").replace(/\"/g, "");
  },

  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    // 用户访问权限
    userJurisdiction() {
      return this.$store.state.roleMenu;
    },
    // 用户控制权限
    canControl() {
      return this.userJurisdiction.indexOf("equipmentInfo:look") !== -1;
    },
    // 入住退房权限
    inOutPermission() {
      return this.userJurisdiction.includes("roomStatus:pms");
    },
  },

  methods: {
    // 获取动态时间
    getTime() {
      const now = moment();
      this.dateTime = now.format("YYYY-MM-DD HH:mm:ss");
      const weeks = {
        0: "星期天",
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
      };
      this.week = weeks[now.day()];
    },
    // 设置定时器
    setInterval() {
      this.timer = setInterval(() => {
        this.getTime();
      }, 1000);
    },

    // 客房查询
    roomSearch() {
      if (this.number === "") {
        this.$message.error("请输入房间号");
        return;
      }
      this.$emit("room-search", this.number);
    },
    // 入住弹窗
    inOut() {
      this.visibleInOut = true;
    },

    // 开空调
    // openAir() {
    //   this.$emit("open-air", true);
    // },
    // 客控工具
    handleControl(command) {
      this.$emit("open-command", command);
    },

    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      } else {
        this.visibleReset = true;
      }
    },

    // 退出登录
    logout() {
      this.$store.commit("SET_TOKEN");
      sessionStorage.clear();
      location.reload();
      this.$destroy();
    },
    update() {
      this.$emit("update", true);
    },

    play() {
      this.$emit("play", true);
    },
    pause() {
      this.$emit("pause", true);
    },

    backOld() {
      this.$router.push("/kfjk");
    },
  },
};
</script>
<style scoped lang="scss">
$primary: #409eff;
$border: rgba(255, 255, 255, 0.5);
.title {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
}

.gap-l {
  margin-left: 24px;
}

@media screen and (max-width: 1440px) {
  .gap-l {
    margin-left: 16px;
  }
}

.pointer:hover {
  color: #57bff7;
}

// 半透明按钮
.button {
  height: 40px;
  padding: 0 8px;
  min-width: 80px;
  border: 1px solid $border;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
  }
  &:active {
    opacity: 0.8;
  }
}

.room-search {
  .input {
    box-sizing: border-box;
    border: 1px solid $border;
    border-right: none;
    padding: 0 16px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    outline: none;
    height: 40px;
    width: 150px;
    color: #fff;
    background: transparent;
    &::placeholder {
      color: #ccc;
    }
    &:focus {
      outline: 1px solid rgba(255, 255, 255, 0.9);
      outline-offset: -1px;
    }
  }
  .el-icon-error {
    position: absolute;
    right: 8px;
    top: 8px;
    font-size: 24px;
    cursor: pointer;
    color: #ccc;
  }
  .button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.user {
  color: #f7f7f7;
}

.pointer {
  &:hover {
    cursor: pointer;
    color: #1890ff;
    svg path {
      fill: #1890ff;
    }
  }
}
</style>
